import { ReactNode } from 'react';

export interface FieldSelectDataItemTypes {
    value: any;
    label: string;
    icon?: string;
    disabledDesc?: string;
    disabled?: boolean;
    extraLabel?: React.ReactNode; // 自定义列表展示内容样式
    key?: string;
}

export interface FieldSelectProps {
    value?: string | number;
    className?: string;
    data?: FieldSelectDataItemTypes[];
    onChange?: (v: string) => void;
    onSearch?: (v: string) => void;
    placeholder?: string;
    size?: 'large' | 'small' | 'middle';
    notFoundContent?: ReactNode;
    disabled?: boolean;
    /**
     * picker 的弹窗标题， select 的 label
     */
    label?: string;
    /**
     * picker 的弹窗搜索框 placeholder
     */
    searchPlaceholder?: string;
    showSearch?: boolean;
    renderInComponent?: boolean;
    dropdownHeader?: React.ReactNode;
    onSearchInputClick?: () => void;
    id?: string; // 用于给组件内的 Select 的父容器赋予 id, 便于将 Select 的下拉框定位在组件内部
    optionLabelProp?: string; // 回填到选择框的属性值
    filterOption?: boolean;
}
